import { Dispatch, SetStateAction, useState } from "react";
import { CFieldType } from "../../../../types/RecordInterfaces";
import { FieldOptionsType } from "../ComplexField";
import { Input } from "reactstrap";
import Phone from "../../../Inputs/Phone";
import { Tooltip, Whisper } from "rsuite";
import useToggle from "../../../../hooks/useToggle";
import OptionType from "./OptionType";
import IconButton from "../../../../elements/IconButton";
import Options from "./Options";
import {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  parsePhoneNumber,
} from "react-phone-number-input";
import _ from "underscore";

interface Props {
  complexVal: CFieldType;
  onChange: Dispatch<SetStateAction<CFieldType[]>>;
  setEditorOpen: Dispatch<SetStateAction<boolean>>;
  setError: (error: string) => void;
  setIsEditing: (value: boolean) => void;
  onOpen: () => void;
  onEdit: () => void;
  error?: string | null;
  FieldOptions: FieldOptionsType;
}

const PhoneOption = ({
  complexVal,
  onChange,
  setIsEditing,
  setError,
  onEdit,
  setEditorOpen,
  FieldOptions,
}: Props) => {
  const [existingValue, setValue] = useState(complexVal);
  const [edit, toggleEdit] = useToggle();

  return (
    <div className="d-flex w-100 justify-content-between align-items-center ">
      <div className="d-flex justify-content-between ">
        {/* Phone Type */}
        {!edit && (
          <>
            <OptionType
              complexVal={complexVal}
              fieldType="Phone"
              setIsEditing={setIsEditing}
              setValue={setValue}
              editValue={editValue}
              FieldOptions={FieldOptions}
            />
            <div className="d-flex align-items-center justify-content-between">
              <Whisper
                onClick={onEdit}
                speaker={<Tooltip>Click to Edit.</Tooltip>}
              >
                <span className="cursor-pointer">
                  <div className={`pr-3`} style={{ fontSize: "13px" }}>
                    {getFormattedPhoneNumber(existingValue?.Phone)}
                    {existingValue.Extension
                      ? ` ext. ${existingValue?.Extension}`
                      : ""}
                  </div>
                </span>
              </Whisper>
            </div>
          </>
        )}
      </div>
      {/* Edit Phone */}
      {edit && (
        <div className="d-flex align-items-center justify-content-between w-100">
          <div style={{ width: "85%" }} className="d-flex flex-column">
            <Phone
              disabled={false}
              onChange={(val: any) => {
                setValue((prev) => ({ ...prev, Phone: val }));
              }}
              existingValue={existingValue.Phone}
              /* @ts-ignore */
              inputSize="sm pb-2 m-0"
            />
            <h5>Ext.</h5>
            <Input
              placeholder="123"
              value={existingValue.Extension}
              onChange={(val) => {
                setValue((prev) => ({ ...prev, Extension: val.target.value }));
              }}
              /* @ts-ignore */
              size="sm"
            />
          </div>
          <IconButton
            onClick={() => {
              setEditorOpen(false);
              if (
                existingValue.Phone === null ||
                existingValue.Phone === undefined ||
                existingValue.Phone === ""
              )
                return;
              if (_.isEqual(existingValue, complexVal)) return toggleEdit();
              editValue(complexVal.id, existingValue);
              // toggleEdit();
            }}
            color="primary"
            icon="mdi mdi-check"
          />
        </div>
      )}
      {!edit && (
        <Options
          fieldType="Phone"
          itemId={complexVal.id}
          setIsEditing={setIsEditing}
          complexVal={complexVal}
          existingValue={existingValue}
          onChange={onChange}
          setOptionValue={setValue}
        />
      )}
    </div>
  );

  function editValue(id: string, newVal: CFieldType) {
    onChange((prev: Array<CFieldType>) => {
      return prev.map((email) => {
        if (email.id === id) return newVal;
        return email;
      });
    });
  }

  function getFormattedPhoneNumber(value?: string) {
    if (!value || typeof value !== "string") {
      return "--";
    }
    const parsed = parsePhoneNumber(value || "");

    if (!parsed) return "--";

    if (parsed.countryCallingCode === "1") {
      return formatPhoneNumber(value as any) || "--";
    }

    return formatPhoneNumberIntl(value as any) || "--";
  }
};

export default PhoneOption;
